var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.77203C11.96 4.76537 11.9133 4.76537 11.8733 4.77203C10.9533 4.7387 10.22 3.98537 10.22 3.05203C10.22 2.0987 10.9866 1.33203 11.94 1.33203C12.8933 1.33203 13.66 2.10537 13.66 3.05203C13.6533 3.98537 12.92 4.7387 12 4.77203Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3133 9.62547C12.2267 9.77881 13.2333 9.6188 13.94 9.14547C14.88 8.5188 14.88 7.49214 13.94 6.86547C13.2267 6.39214 12.2067 6.23214 11.2933 6.39214",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98001 4.77203C4.02001 4.76537 4.06667 4.76537 4.10667 4.77203C5.02667 4.7387 5.76001 3.98537 5.76001 3.05203C5.76001 2.0987 4.99334 1.33203 4.04001 1.33203C3.08668 1.33203 2.32001 2.10537 2.32001 3.05203C2.32667 3.98537 3.06001 4.7387 3.98001 4.77203Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 9.62547C3.75335 9.77881 2.74669 9.6188 2.04002 9.14547C1.10002 8.5188 1.10002 7.49214 2.04002 6.86547C2.75336 6.39214 3.77335 6.23214 4.68669 6.39214",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 9.7525C7.95997 9.74584 7.9133 9.74584 7.8733 9.7525C6.9533 9.71917 6.21997 8.96583 6.21997 8.0325C6.21997 7.07917 6.98664 6.3125 7.93997 6.3125C8.8933 6.3125 9.65997 7.08583 9.65997 8.0325C9.6533 8.96583 8.91997 9.72584 7.99997 9.7525Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05998 11.8542C5.11998 12.4809 5.11998 13.5076 6.05998 14.1342C7.12665 14.8476 8.87331 14.8476 9.93998 14.1342C10.88 13.5076 10.88 12.4809 9.93998 11.8542C8.87998 11.1476 7.12665 11.1476 6.05998 11.8542Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.cb83006dbca435651e242ca6e75161c4.svg";
export { ForwardRef as ReactComponent };